import { render, staticRenderFns } from "./XuatKhoForm.vue?vue&type=template&id=cb1c3e64&"
import script from "./XuatKhoForm.vue?vue&type=script&lang=js&"
export * from "./XuatKhoForm.vue?vue&type=script&lang=js&"
import style0 from "./XuatKhoForm.vue?vue&type=style&index=0&id=cb1c3e64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports